import CommonItems from "components/common-item/CommonItems";
import EmptyBlockSecondary from "components/placeholder-blocks/EmptyBlockSecondary";
import Loader from "components/Loader";
import Pagination from "components/Pagination";
import { useOutletContext } from "react-router-dom";
import MainContentLeft from "components/main-components/MainContentLeft";
import PageLoader from "components/page-components/PageLoader";

const Triggers = () => {
  const {
    items,
    filters,
    isFiltersLoading,
    isItemsLoading,
    offsetCount,
    setOffsetCount,
    paginationData,
    getOpenedClass,
  } = useOutletContext();

  if (!items.length && isFiltersLoading === true) {
    return <PageLoader />;
  }

  return (
    <main className="main-content">
      <MainContentLeft
        getOpenedClass={getOpenedClass}
        filters={filters}
        setOffsetCount={setOffsetCount}
      />
      <div className="main-content__right">
        {isItemsLoading && !items.length ? (
          <Loader />
        ) : items.length ? (
          <>
            <CommonItems items={items} />
            <Pagination
              offsetCount={offsetCount}
              setOffsetCount={setOffsetCount}
              paginationData={paginationData}
            />
          </>
        ) : (
          <EmptyBlockSecondary type={"triggers"} />
        )}
      </div>
    </main>
  );
};

export default Triggers;
